import Component from 'vue-class-component';
import { Vue } from 'vue-property-decorator';
import {Role} from "@/shared/model/enumerations/role.model";

@Component
export default class Login extends Vue {
    private logout() {
        sessionStorage.removeItem('jhi-authenticationToken');
        localStorage.removeItem('jhi-authenticationToken');
        this.$router.push('/');
    }

    private get isAdmin() {
        return this.$store?.getters?.account?.role?.code === Role.ADMIN;
    }
}

